<script>
import { readAllCategories, getDoluFromDbase } from '@/services/MindMovieServices';
import AddMindMoviePost from './AddMindMoviePost';

export default {
  components: { AddMindMoviePost },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      doluLocal: localStorage.getItem('doluCategories'),
      doluDbase: null,
      categoriesLocal: JSON.parse(localStorage.getItem('categories')),

      categories: null,
      categoriesObjectNameIsKeyIdIsValue: {},
    };
  },
  async created() {
    const dolusFromDbase = await getDoluFromDbase(this.uId, this.token);
    this.doluDbase = dolusFromDbase.categories;

    if (!this.categoriesLocal || !this.doluLocal || this.doluLocal !== this.doluDbase) {
      this.categories = await readAllCategories(this.uId, this.token);
    }
    else {
      this.categories = this.categoriesLocal;
    }

    if (this.categories) {
      for (let i of Object.keys(this.categories)) {
        this.categoriesObjectNameIsKeyIdIsValue[this.categories[i].name] = i;
      }
    }

  },
};
</script>

<template>
  <div class="h-100 w-100 d-flex flex-column justify-space-evenly">

    <router-link to="/mindmovie-categories" class="ml-3 mt-3 mt-5 d-flex justify-center text-decoration-none">
      <v-btn class="text-capitalize text-white w-75" color="red-lighten-2">Edit MindMovie Categories</v-btn>
    </router-link>

    <router-link to="/mindmovie" class="ml-3 mt-3 mt-5 d-flex justify-center text-decoration-none">
      <v-btn class="text-capitalize text-white w-75" color="blue-lighten-2">View/Edit MindMovie Posts</v-btn></router-link>

    <AddMindMoviePost v-if="categories" :categories="categories" :categoriesByName="categoriesObjectNameIsKeyIdIsValue" />

  </div>
</template>
